<template>
  <div class="main-content" id="panel">
    <!-- Header -->
    <!-- <Header /> -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <h2>View Imported Data</h2>
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                  <li class="breadcrumb-item">
                    <i class="fas fa-home"></i>
                  </li>
                  <li class="breadcrumb-item">Data Aggregator</li>
                  <li class="breadcrumb-item active" aria-current="page">View Imported Data</li>
                </ol>
              </nav>
            </div>
            <div class="col-lg-6 col-5 text-right"></div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="filter">
              <h3>FILTERED BY</h3>
              <form>
                <div class="form-group">
                  <label for="exampleFormControlInput1">ACCOUNT NO</label>
                  <input
                    type="text"
                    v-model="accountNo"
                    class="form-control"
                    id="account"
                    placeholder="Enter Account No"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleFormControlInput1">TRADE DATE</label>
                  <input
                    type="date"
                    v-model="tradeDate"
                    class="form-control"
                    id="date"
                    placeholder="MM/DD/YYYYY"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleFormControlInput1">CUSIP</label>
                  <input
                    type="text"
                    v-model="cusip"
                    class="form-control"
                    id="cusip"
                    placeholder="Enter CUSIP"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleFormControlSelect1">PURPOSE</label>
                  <select class="form-control" id="purpose" v-model="purposeId">
                    <option value>Please select</option>
                    <option value="0">No Purpose</option>
                    <option
                      v-for="purpose in purposes"
                      :key="purpose.id"
                      v-bind:value="purpose.id"
                    >{{purpose.purpose}}</option>
                  </select>
                </div>
                <div class="text-center">
                  <button @click="filterTradeData()" type="button" class="btn btn-primary my-2">
                    FILTER
                    <i v-if="!loading" class="fas fa-filter"></i>
                    <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                  </button>
                  <button
                    @click="clearFilter()"
                    v-if="accountNo || tradeDate || cusip || purposeId || purposeId == '0'"
                    type="button"
                    class="btn btn-secondary my-2"
                  >CLEAR</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="card scrollbar" id="scroll">
            <div class="card-header bg-transparent">
              <div class="row align-items-center">
                <div class="col">
                  <h3>View Imported Data</h3>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <div v-if="loading" class="loader"><img src="../../assets/img/loader.svg" alt=""/></div>
              <table id="example" class="table align-items-center table-flush table-hover">
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col" >Reference #</th>
                    <th scope="col" >Cusip</th>
                    <th scope="col" >Account #</th>
                    <th scope="col" >Trade Date</th>
                    <th scope="col" >Quantity</th>
                    <th scope="col" >Interest Rate</th>
                    <th scope="col" >Next Call Date</th>
                    <th scope="col" >Moody's Rating</th>
                    <th scope="col" >S&P Rating</th>
                    <th scope="col" >State</th>
                    <th scope="col" >Purpose</th>
                    <th scope="col" >Maturity Date</th>
                    <th scope="col" >Bond Insurer</th>
                    <th scope="col" >Description</th>
                    <th scope="col" >Action</th>
                    <!-- <th scope="col" class="sort">Account</th>
                    <th scope="col" class="sort">Trade Date</th>
                    <th scope="col" class="sort">Cusip</th>
                    <th scope="col" class="sort">Security Description</th>
                    <th scope="col" class="sort text-right">Quantity</th>
                    <th scope="col" class="sort text-right">Price</th>
                    <th scope="col" class="sort text-right">Interest</th>
                    <th scope="col" class="sort">Bond</th>
                    <th scope="col" class="sort text-center">Purpose</th>
                    <th scope="col" class="sort">Action</th>-->
                  </tr>
                </thead>
                <tbody class="list">
                  <tr v-for="trade in trades" :key="trade.id">
                    <td>{{trade.reference_no}}</td>
                    <td>{{trade.cusip}}</td>
                    <td>{{trade.account_no}}</td>
                    <td>{{trade.trade_date}}</td>
                    <td>{{trade.quantity}}</td>
                    <td class="text-center">{{trade.interest_rate}}</td>
                    <td>{{trade.next_call_date}}</td>
                    <td class="text-center">
                      <span class="pill red">{{trade.moodys_rating}}</span>
                    </td>
                    <td class="text-center">
                      <span class="pill green">{{trade.s_p_rating}}</span>
                    </td>
                    <td>{{trade.state}}</td>
                    <td>{{trade.purpose}}</td>
                    <td class="text-center">{{trade.maturity_date}}</td>
                    <td style="white-space:pre-wrap; word-wrap:break-word">{{trade.bond_insurer}}</td>
                    <td style="white-space:pre-wrap; word-wrap:break-word">{{trade.description}}</td>
                    <td>
                      <a
                        href="#"
                        @click="deleteTradeId = trade.id"
                        data-toggle="modal"
                        data-target="#deleteModal"
                      >
                        <span class="btn-icon">
                          <i class="far fa-trash-alt"></i>
                        </span>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getTradeData(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{totalRows}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
      <!-- Modal -->
      <div
        class="modal fade"
        id="deleteModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <i class="fas fa-exclamation-triangle"></i>
              <p>Are you sure you want to delete this data?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-danger" @click="deleteTradeData()">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Header from "../common/Header";
// import Footer from "../common/Footer";
import config from "@/config";

// import DataTable from 'datatables'

//import $ from "jquery";
//import this.$http from "this.$http";

export default {
  name: "viewdata",
  components: {
    // Header,
    // Footer
  },
  data() {
    return {
      accessToken: null,
      trades: [],
      purposes: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      cusip: "",
      purposeId: "",
      accountNo: "",
      tradeDate: "",
      deleteTradeId: null,
      loading: false
    };
  },
  created() {},
  methods: {
    getTradeData(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/trade/list?startAt=" +
            (currentPage * 10 - 10) +
            "&perPage=" +
            this.perPage +
            "&accountNo=" +
            this.accountNo +
            "&cusip=" +
            this.cusip +
            "&tradeDate=" +
            this.tradeDate +
            "&purposeId=" +
            this.purposeId,
          auth
        )
        .then(result => {
          console.log(result);
          this.totalRows = result.data.count;
          this.trades = result.data.data;
          this.loading = false;
        })
        .catch(e => {
          console.log("Error", e);
          self.loading = false;
        });
    },
    filterTradeData() {
      //this.loading = true;
      this.getTradeData();
    },
    clearFilter() {
      this.accountNo = this.cusip = this.tradeDate = this.purposeId = "";
      this.getTradeData();
    },
    deleteTradeData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .delete(config.baseUrl + "/trade/" + this.deleteTradeId, auth)
        .then(result => {
          console.log(result);
          this.getTradeData(this.currentPage);
          window.$("#deleteModal").modal("hide");
        });
    },
    getPurposeList() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http.get(config.baseUrl + "/purpose/list", auth).then(result => {
        this.purposes = result.data.data;
      });
    }
  },
  mounted(currentPage) {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getTradeData(currentPage);
        this.getPurposeList();
      }
    });
  }
};
</script>
<style scoped>
</style>